import {
  DayPickerStrings,
  FormikGraphQLDatePicker,
  onFormatDate,
} from 'components'
import { FormikCheckbox, FormikTextField } from 'formik-office-ui-fabric-react'
import { Box } from 'grid'
import { OrderIdInsertType, OrderIdSetType } from 'model'
import { DayOfWeek, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import { FieldStack, FieldStackItem, FormStack } from '../FormStack'

export type OrderIdFormValues = OrderIdInsertType | OrderIdSetType

Yup.setLocale({
  date: {
    when: 'ERROR',
  },
})

export class OrderIdFormSchema {
  constructor() {
    return Yup.object().shape({
      value: Yup.string().required(),
      validFrom: Yup.date().required(),
      validTo: Yup.date()
        .required()
        .when(
          'validFrom',
          (validFrom: any, schema: any) => validFrom && schema.min(validFrom)
        ),
    })
  }
}

export const OrderIdForm: React.FunctionComponent = () => {
  const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="value"
          label={t('field.value.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="validFrom"
          label={t('field.validFrom.label')}
          isRequired={true}
          component={FormikGraphQLDatePicker}
          firstDayOfWeek={DayOfWeek.Monday}
          strings={DayPickerStrings}
          showWeekNumbers={true}
          formatDate={onFormatDate}
        />
        <FieldStackItem
          name="validTo"
          label={t('field.validTo.label')}
          isRequired={true}
          component={FormikGraphQLDatePicker}
          firstDayOfWeek={DayOfWeek.Monday}
          strings={DayPickerStrings}
          showWeekNumbers={true}
          formatDate={onFormatDate}
        />
      </FieldStack>
      <FieldStack>
        <Box py={4}>
          <FieldStackItem
            stack={{ grow: 0 }}
            name="inactive"
            render={(fieldProps) => (
              <>
                <Label>{t('field.inactive.label')}</Label>
                <Box py={1}>
                  <FormikCheckbox {...fieldProps} />
                </Box>
              </>
            )}
          />
        </Box>
      </FieldStack>
    </FormStack>
  )
}
